module.exports = __webpack_public_path__ + "static/media/voucher.fa3032ba.svg";